import React, { lazy } from 'react';
import { CheckCircle2, Maximize, DoorOpen, ShieldAlert } from 'lucide-react';
export function SideDoorRear() {
  const items = [{
    title: 'Side Window Replacement',
    icon: <Maximize className="w-6 h-6 text-brand-blue" data-id="element-608" data-mp="18qoi5yx74b15" />,
    bullets: ['Driver and passenger side windows', 'Power window glass and quarter glass', 'Cars, trucks, vans and SUVs']
  }, {
    title: 'Door Glass Replacement',
    icon: <DoorOpen className="w-6 h-6 text-brand-blue" data-id="element-609" data-mp="1ilzz8nw2tuc2" />,
    bullets: ['Shattered or broken car door glass', 'Most domestic and foreign vehicles', 'Cleanup of broken glass from the door']
  }, {
    title: 'Rear Window Replacement',
    icon: <ShieldAlert className="w-6 h-6 text-brand-blue" data-id="element-610" data-mp="1nfuoe6ugb1ij" />,
    bullets: ['Cracked or shattered rear glass', 'Defrost line reconnection where applicable', 'Truck rear windows and back glass']
  }];
  return <section className="py-16 lg:py-24 bg-white" data-id="element-611" data-mp="3o2y6sn9wzb5b">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-612" data-mp="3o498mhjsu8ts">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-14 items-center mb-16" data-id="element-613" data-mp="3t2kkextnmten">
          <div className="order-2 lg:order-1 scroll-slide-left" data-id="element-614" data-mp="1uyk9f65992j">
            <h2 className="text-3xl md:text-4xl font-bold text-navy-900 mb-4" data-id="element-615" data-mp="6ub73zx0mg54">
              Side, Door & Rear Window Replacement
            </h2>
            <p className="text-lg text-slate-600 leading-relaxed" data-id="element-616" data-mp="av4vsvia7yz2">
              A shattered side window or broken rear glass leaves your vehicle
              exposed to weather, theft and further damage. Kosin's Glass
              replaces side, door and rear glass for most makes and models, with
              quality glass and certified installation.
            </p>
          </div>

          <div className="order-1 lg:order-2 relative scroll-slide-right" data-id="element-617" data-mp="ukx4mx9e8i0v">
            <div className="rounded-lg overflow-hidden shadow-xl shadow-slate-300/40 border border-slate-200" data-id="element-618" data-mp="yl7iew3fgcqa">
              <img src="https://cdn.magicpatterns.com/uploads/9dCxjUiqV7wDbE5eDQnv4o/autoglasspic2.webp" alt="Shattered rear window on a vehicle. Kosin's Glass replaces broken rear and side glass." className="block w-full h-64 lg:h-80 object-cover" loading="lazy" data-id="element-619" data-mp="2vlbswdm82c8r" />
            </div>
            <div className="hidden lg:block absolute -top-4 -left-4 w-24 h-24 bg-brand-blue rounded-lg -z-10" data-id="element-620" data-mp="2zlvp9eyz1btu" />
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-621" data-mp="39eb4w5mspobk">
          {items.map((item, i) => <div key={i} className="bg-slate-50 rounded-lg p-8 border border-slate-100 scroll-fade-up" style={{
          animationDelay: `${i * 0.08}s`
        }} data-id="element-622" data-mp="3ndkkb336geeh" data-mpi={i}>
              <div className="w-12 h-12 bg-brand-light rounded-lg flex items-center justify-center mb-5" data-id="element-623" data-mp="1szjnsov3o3hk">
                {item.icon}
              </div>
              <h3 className="text-xl font-bold text-navy-900 mb-4" data-id="element-624" data-mp="1et81ydoqvktn">
                {item.title}
              </h3>
              <ul className="space-y-3" data-id="element-625" data-mp="1iua0ster1uv3">
                {item.bullets.map((b, j) => <li key={j} className="flex items-start gap-2.5" data-id="element-626" data-mp="154q1xyoahhr2" data-mpi={j}>
                    <CheckCircle2 className="w-5 h-5 text-brand-blue shrink-0 mt-0.5" data-id="element-627" data-mp="1a31bs9el3s9a" />
                    <span className="text-slate-700" data-id="element-628" data-mp="1a0om1a2l4dlo">{b}</span>
                  </li>)}
              </ul>
            </div>)}
        </div>

        <div className="text-center mt-12" data-id="element-629" data-mp="106esvq5tjb9w">
          <a href="#quote" className="inline-flex items-center justify-center bg-brand-blue hover:bg-brand-hover text-white font-bold py-4 px-8 rounded-lg transition-colors shadow-lg shadow-brand-blue/20" data-id="element-630" data-mp="m52fnmi1lnrp">
            Request a Side, Door or Rear Window Quote
          </a>
        </div>
      </div>
    </section>;
}